const Index = resolve => require(['@/pages/juhe'], resolve)
const routes = [{
    path: '/acthome/juhe/:cityid',
    name: 'juhe',
    component: Index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/route/index.js